import { render, staticRenderFns } from "./BuscarUsuario.vue?vue&type=template&id=12a596cc&scoped=true&"
import script from "./BuscarUsuario.vue?vue&type=script&lang=js&"
export * from "./BuscarUsuario.vue?vue&type=script&lang=js&"
import style0 from "./BuscarUsuario.vue?vue&type=style&index=0&id=12a596cc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12a596cc",
  null
  
)

export default component.exports